import { render } from "./DeletionMethodsSection.vue?vue&type=template&id=42a1f6f7&scoped=true"
import script from "./DeletionMethodsSection.vue?vue&type=script&lang=js"
export * from "./DeletionMethodsSection.vue?vue&type=script&lang=js"

import "./DeletionMethodsSection.vue?vue&type=style&index=0&id=42a1f6f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a1f6f7"]])

export default __exports__